import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram } from 'react-icons/fi';

const FooterShed = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Browse Sheds', href: '/sheds' },
    { name: 'Find a Dealer', href: '/dealers' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Shed Wanted', href: '/shed-wanted' },
    { name: 'Compare Sheds', href: '/compare' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact', href: '/contact' },
    { name: 'Warranty', href: '/warranty' },
    { name: 'Dealer Login', href: '/dealer/login' },
  ];

  const shedTypes = [
    { name: 'Barn Style Sheds', href: '/sheds?type=barn' },
    { name: 'Gable Sheds', href: '/sheds?type=gable' },
    { name: 'Workshops', href: '/sheds?type=workshop' },
    { name: 'Studio Sheds', href: '/sheds?type=studio' },
    { name: 'Garage Buildings', href: '/sheds?type=garage' },
    { name: 'Cabanas', href: '/sheds?type=cabana' },
  ];

  const legalLinks = [
    { name: 'Terms & Conditions', href: '/terms-and-conditions' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Refund Policy', href: '/refund-policy' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Disclaimer', href: '/disclaimer' },
  ];

  return (
    <footer className="bg-gray-950 text-gray-400">
      <div className="container mx-auto px-4 py-14">
        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10 mb-12">
          <div className="max-w-xs">
            <Link to="/" className="inline-block mb-3">
              <span className="text-lg font-semibold tracking-tight text-white">ShedX</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Storage buildings, workshops and outdoor structures. Free delivery and professional setup.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-16 gap-y-8">
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-600 mb-3">Pages</p>
              <ul className="space-y-2 text-sm">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-gray-400 hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-600 mb-3">Shed types</p>
              <ul className="space-y-2 text-sm">
                {shedTypes.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-gray-400 hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-600 mb-3">Contact</p>
              <ul className="space-y-2 text-sm">
                <li><a href="mailto:sales@shedx.com" className="hover:text-white transition-colors">sales@shedx.com</a></li>
                <li className="text-gray-500">Mon–Fri 8AM–5PM</li>
                <li className="text-gray-500">Sat 9AM–3PM</li>
              </ul>
              <div className="flex gap-3 mt-4">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-white transition-colors">
                  <FiFacebook className="w-4 h-4" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-white transition-colors">
                  <FiInstagram className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <span className="text-xs text-gray-600">
            &copy; {currentYear} ShedX. All rights reserved.
          </span>
          <div className="flex flex-wrap gap-4 text-xs text-gray-600">
            {legalLinks.map((link) => (
              <Link key={link.name} to={link.href} className="hover:text-gray-400 transition-colors">
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterShed;
